var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"resize-wp",class:_vm.resizeSide,style:(_vm.style)},[_vm._t("default"),_c('div',{staticClass:"btn-resize",on:{"mousedown":function($event){$event.preventDefault();return _vm.resizeStart.apply(null, arguments)}}})],2)}
var staticRenderFns = []

export { render, staticRenderFns }